import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Recital } from '../model/recital';

export const getRecitalAPI = async (recitalId: string) => {
  const response = await baseAPI.get<Recital>(`/recitals/${recitalId}`);
  return response.data;
};

export const getRecitalOptions = (recitalId: string) => {
  return queryOptions({
    queryKey: [KEYS.RECITALS, recitalId],
    queryFn: () => getRecitalAPI(recitalId),
    staleTime: 1000 * 60 * 5,
  });
};

export const useGetRecital = (recitalId: string) => {
  return useQuery(getRecitalOptions(recitalId));
};
